import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

const DeviceGuard = ({ children }) => {
    const theme = useTheme();
    const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobileOrTablet) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default DeviceGuard; 